import { c as _c } from "react/compiler-runtime";
/**
 * "Lean on the Experts" CTA Component
 *
 * Displayed on category pages to encourage custom quotes.
 * Ported from Magento theme: add_to_cart_block.phtml
 */

import Link from 'next/link';
import Image from '@/components/media/StorefrontImage';
export interface LeanOnExpertsConfig {
  blockId?: string;
  imageSrc?: string;
  sourceImageSrc?: string;
  imageAlt?: string;
  eyebrow?: string;
  heading?: string;
  description?: string;
  leadIn?: string;
  ctaLabel?: string;
  ctaHref?: string;
}
export interface LeanOnExpertsProps {
  config?: LeanOnExpertsConfig;
}
const DEFAULT_IMAGE_SRC = 'https://scw-commerce-media.s3.amazonaws.com/pub/media/images/get-the-experts3.png';
export function LeanOnExperts(t0) {
  const $ = _c(31);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    config: t2
  } = t1;
  let t3;
  if ($[2] !== t2) {
    t3 = t2 === undefined ? {} : t2;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const config = t3;
  const imageSrc = config.imageSrc ?? DEFAULT_IMAGE_SRC;
  const t4 = config.imageAlt ?? "";
  let t5;
  if ($[4] !== config.sourceImageSrc || $[5] !== imageSrc || $[6] !== t4) {
    t5 = <div className="lean-on-experts__image-layer" aria-hidden="true"><Image src={imageSrc} data-src={config.sourceImageSrc} alt={t4} width={1920} height={562} className="lean-on-experts__background-img" priority={false} /></div>;
    $[4] = config.sourceImageSrc;
    $[5] = imageSrc;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = config.eyebrow ?? "NOT SURE WHAT YOU NEED?";
  let t7;
  if ($[8] !== t6) {
    t7 = <span className="lean-on-experts__subheading">{t6}</span>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = config.heading ?? "Lean on the experts";
  let t9;
  if ($[10] !== t8) {
    t9 = <h2 className="lean-on-experts__title">{t8}</h2>;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const t10 = config.description ?? "We'd be happy to work up a custom quote or take your floorplan and create a security coverage map.";
  let t11;
  if ($[12] !== t10) {
    t11 = <p className="lean-on-experts__description">{t10}</p>;
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const t12 = config.leadIn ?? "Get a";
  let t13;
  if ($[14] !== t12) {
    t13 = <span className="lean-on-experts__cta-label">{t12}</span>;
    $[14] = t12;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  const t14 = config.ctaHref ?? "/get-a-quote";
  const t15 = config.ctaLabel ?? "CUSTOM QUOTE";
  let t16;
  if ($[16] !== t14 || $[17] !== t15) {
    t16 = <Link href={t14} className="lean-on-experts__button" data-cms-cta={true}>{t15}</Link>;
    $[16] = t14;
    $[17] = t15;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== t13 || $[20] !== t16) {
    t17 = <p className="lean-on-experts__cta">{t13}{t16}</p>;
    $[19] = t13;
    $[20] = t16;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== t11 || $[23] !== t17 || $[24] !== t7 || $[25] !== t9) {
    t18 = <div className="lean-on-experts__content">{t7}{t9}{t11}{t17}</div>;
    $[22] = t11;
    $[23] = t17;
    $[24] = t7;
    $[25] = t9;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== config.blockId || $[28] !== t18 || $[29] !== t5) {
    t19 = <section className="lean-on-experts" data-cms-block-id={config.blockId}>{t5}{t18}</section>;
    $[27] = config.blockId;
    $[28] = t18;
    $[29] = t5;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  return t19;
}